// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","image":"App_image__3byI1","imageJuntos":"App_imageJuntos__1gHCV","footer":"App_footer__29Fsv","language":"App_language__3Hx9r"};